import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoaderCircle } from 'lucide-react';
import { useApp } from './context/AppContext';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { todayInTimezone } from './lib/date';
import { Button } from './components/UI';

const DayPage = lazy(() => import('./pages/DayPage').then((module) => ({ default: module.DayPage })));
const CalendarPage = lazy(() => import('./pages/CalendarPage').then((module) => ({ default: module.CalendarPage })));
const ProgramPage = lazy(() => import('./pages/ProgramPage').then((module) => ({ default: module.ProgramPage })));
const DashboardPage = lazy(() => import('./pages/DashboardPage').then((module) => ({ default: module.DashboardPage })));
const MorePage = lazy(() => import('./pages/MorePage').then((module) => ({ default: module.MorePage })));
const ExercisesPage = lazy(() => import('./pages/ExercisesPage').then((module) => ({ default: module.ExercisesPage })));
const BodyWeightPage = lazy(() => import('./pages/BodyWeightPage').then((module) => ({ default: module.BodyWeightPage })));
const ExportPage = lazy(() => import('./pages/ExportPage').then((module) => ({ default: module.ExportPage })));
const SettingsPage = lazy(() => import('./pages/SettingsPage').then((module) => ({ default: module.SettingsPage })));
const HelpPage = lazy(() => import('./pages/HelpPage').then((module) => ({ default: module.HelpPage })));
const WorkoutPage = lazy(() => import('./pages/WorkoutPage').then((module) => ({ default: module.WorkoutPage })));

export function App() {
  const { loading, authenticated, data, conflicts, keepLocalConflict, useServerConflict } = useApp();
  if (loading) return <div className="app-loader"><div className="brand__mark">С</div><LoaderCircle className="spin" /><span>Загружаю дневник…</span></div>;
  if (!authenticated || !data) return <LoginPage />;
  const today = todayInTimezone(data.settings.timezone);
  return <AppShell>
    {conflicts.length > 0 && <aside className="conflict-banner"><div><strong>Изменения с двух устройств</strong><span>Выберите, какую версию сохранить.</span></div><div>{conflicts.map((conflict) => <div key={conflict.id}><Button variant="secondary" onClick={() => void useServerConflict(conflict)}>С сервера</Button><Button onClick={() => void keepLocalConflict(conflict)}>С этого устройства</Button></div>)}</div></aside>}
    <Suspense fallback={<div className="route-loader"><LoaderCircle className="spin" /> Загружаю раздел…</div>}><Routes>
      <Route path="/" element={<Navigate to={`/day/${today}`} replace />} />
      <Route path="/day/:date" element={<DayPage />} />
      <Route path="/workout/:sessionId" element={<WorkoutPage />} />
      <Route path="/calendar" element={<CalendarPage />} />
      <Route path="/program" element={<ProgramPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/more" element={<MorePage />} />
      <Route path="/exercises" element={<ExercisesPage />} />
      <Route path="/weight" element={<BodyWeightPage />} />
      <Route path="/export" element={<ExportPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/help" element={<HelpPage />} />
      <Route path="*" element={<Navigate to={`/day/${today}`} replace />} />
    </Routes></Suspense>
  </AppShell>;
}
